<template>
  <div class="content getMoney">
    <div class="bodycontent">
      <!-- <div class="money-title">消费收银</div> -->
      <div class="money-con">
        <div class="money-list">
          <SideList></SideList>
        </div>
        <!--付款-->
        <div class="money-main">
          <div class="money-center">
            <div>
              <el-card class="box-card">
                <el-input
                  placeholder="搜索"
                  @change="getData"
                  v-model="search_con"
                  clearable
                  class="input-with-select"
                >
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="getData"
                  ></el-button>
                </el-input>
                <div class="screenCont" v-if="show_user_infor">
                  <template v-if="user_infor">
                    <div class="vip-card-number">
                      <span>卡号: {{ user_infor[0].card_num }}</span>
                    </div>
                    <div class="vip-info">
                      <span class="vip-info-item">
                        姓名:
                        <span>{{ user_infor[0].real_name }}</span>
                      </span>
                      <span class="vip-info-item">
                        手机号:
                        <span>{{ user_infor[0].mobile }}</span>
                      </span>
                      <span class="vip-info-item">
                        会员等级:
                        <span>{{ user_infor[0].card_level }}</span>
                      </span>
                      <span class="vip-info-item">
                        余额:
                        <span @click="showUserAccountList(1)">
                          {{ allRechangeAccount }}
                        </span>
                      </span>
                      <span class="vip-info-item">
                        积分数量:
                        <span @click="showUserAccountList(2)">
                          {{ user_infor[0].point }}
                        </span>
                      </span>
                    </div>
                  </template>
                  <div v-else class="noUser">
                    <span>用户暂无开卡</span>
                    <el-button type="primary" size="mini" @click="oneOpenCard">
                      立即开卡
                    </el-button>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card" v-if="oil_infor && !typeMethods">
                <div class="oilinfor">
                  <div class="oilinfor-name">
                    <span>
                      商品:
                      <span class="oil">{{ oil_infor.title }}</span>
                    </span>
                  </div>
                  <div class="oilinfor-unitPrice">
                    积分：¥{{ oil_infor.credit }}
                  </div>
                </div>
                <div class="weight">
                  <span>
                    当前库存:
                    <span style="color: #333;">{{ oil_infor.stock }}件</span>
                  </span>
                </div>
              </el-card>
              <el-card class="box-card" v-if="typeMethods">
                <div class="pay-money">
                  <span>金额</span>
                  <el-input
                    ref="inputPrice"
                    maxlength="6"
                    :autofocus="true"
                    max="10"
                    v-model="inputPrice"
                    oninput="value=value.replace(/[^\-?\d.]/g,'')"
                    placeholder="输入抵扣积分"
                  ></el-input>
                </div>
              </el-card>
            </div>
            <div class="money-center-num">
              <KeyNumber
                class="key-number"
                ref="key_number"
                :money="inputPrice"
                @focusMethods="focusMethods"
              ></KeyNumber>
              <div class="key-right">
                <div
                  v-for="(item, index) in shortcutPrice"
                  :key="index"
                  class="key-right-item"
                  @click="selectPrice(item)"
                >
                  ￥{{ item }}
                </div>
              </div>
            </div>
          </div>
          <money-pay
            ref="moneyPay"
            :user_infor="user_infor"
            :oil_infor="oil_infor"
            :inputPrice="inputPrice"
            :integralNum="integralNum"
            @payEnd="getData"
            :showRemark="typeMethods != 0"
            @status="status"
          ></money-pay>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showUserAccount"
      :title="showAccountTitle"
      @close="closeAccount"
      width="600px"
    >
      <el-table
        :data="accountData"
        v-if="showAccountTitle == '余额变动记录'"
        size="medium"
        border
        v-loading="accountLoading"
        element-loading-text="正在查询..."
      >
        <el-table-column label="变动金额" prop="show_amount"></el-table-column>
        <el-table-column label="变动时间" prop="create_time"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column
          label="操作员手机号"
          prop="operate.mobile"
        ></el-table-column>
      </el-table>
      <el-table
        :data="accountData"
        v-if="showAccountTitle == '积分变动记录'"
        size="medium"
        border
        v-loading="accountLoading"
        element-loading-text="正在查询..."
      >
        <el-table-column label="变动金额" prop="show_amount"></el-table-column>
        <el-table-column label="变动原因" prop="show_style"></el-table-column>
        <el-table-column label="变动时间" prop="create_time"></el-table-column>
        <el-table-column label="说明" prop="text"></el-table-column>
        <el-table-column
          label="操作员手机号"
          prop="operate.mobile"
        ></el-table-column>
      </el-table>
      <div class="pagination" style="margin-top: 10px;">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="accountPage"
          :total="accountTotal"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { searchCardIc } from '@/api/ic'
import { storeList } from '@/api/storeManage'
import moneyPay from './moneyPayIntegral'
import { getBalanceLog, getPointLog, oneOpenCard, vipUserinfo } from '@/api/vip'
import SideList from './sidelistIntegral'
import KeyNumber from '@/components/public/KeyNumber'
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['token', 'app_id']),
  },
  components: {
    SideList,
    KeyNumber,
    moneyPay,
  },
  data() {
    return {
      tabar: 'convenient',
      allRechangeAccount: '',
      room_id: '',
      integralNum: 0, // 积分数量够
      inputPrice: '', // 输入金额
      drawer: false,
      search_con: '', // 搜索内容
      oil_infor: '', // 当前油品信息
      user_infor: '', // 查询用户信息
      fuel_charge: 0, // 加油量
      show_user_infor: false,
      shortcutPrice: ['100', '200', '500', '1000'],
      showUserAccount: false, // 显示用户余额/积分记录
      showAccountTitle: '余额变动记录',
      accountData: [], // 余额/积分记录
      accountPage: 1, // 记录页码
      accountTotal: 0, // 记录总数
      styleList: [
        { id: 0, name: '签到送积分' },
        { id: 1, name: '线下买单' },
        { id: 2, name: '充值' },
        { id: 3, name: '后台变动' },
        { id: 4, name: '回退' },
        { id: 5, name: '其他' },
        { id: 6, name: '积分兑换' },
        { id: 7, name: '邀请新人' },
      ],
      accountLoading: false,
      typeMethods: 0, // 0.商品 1.加积分 2.减积分
    }
  },
  watch: {
    search_con(val) {
      console.log('search_con', val)
      if (val == '') {
        this.show_user_infor = false
        this.$refs.moneyPay.showDiscounts = false
      }
    },
    inputPrice(val) {
      if (val.indexOf('.') > -1) {
        if (val.indexOf('.') == 0) {
          this.inputPrice = '0.'
        } else {
          this.inputPrice = val.substring(0, val.indexOf('.') + 3)
        }
      }
      // 有用户信息时重新查卷
      // if (this.show_user_infor && Number(val) > 0) {
      //   // 获取会员vip
      //   this.$refs.moneyPay.discountAll(
      //     this.user_infor[0].user_level_id,
      //     this.oil_infor.goods.type_id,
      //     this.oil_infor.goods.id,
      //     this.inputPrice
      //   );
      // this.$refs.moneyPay.getAvailable_coupon();
      // this.$refs.moneyPay.openIntegral = false;
      // }
      // this.$refs.key_number.money = val;
    },
    // oil_infor: {
    //   handler() {
    //     if (this.user_infor.length > 0) {
    //       // 获取优惠券列表
    //       // 有金额时才查券
    //       if (this.inputPrice) {
    //         // 获取会员vip
    //         this.$refs.moneyPay.discountAll(
    //           this.user_infor[0].user_level_id,
    //           this.oil_infor.goods.type_id,
    //           this.oil_infor.goods.id,
    //           this.inputPrice
    //         );
    //         // this.$refs.moneyPay.getAvailable_coupon();
    //         // this.$refs.moneyPay.openIntegral = false;
    //       }
    //     }
    //   },
    //   deep: true
    // }
  },
  mounted() {
    this.getShopList()
  },
  methods: {
    Tabar(val) {
      if (val == 'goods') {
        this.$router.push('/apply/newVip/13/business/getMoney')
      }
    },
    // 键盘数据
    focusMethods(val) {
      this.inputPrice = val
    },
    getShopList() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: 1,
        name: '',
      }
      storeList(data).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.room_id = res.data[0].id
        } else if (res.code == 400) {
          this.$message(res.msg)
        } else {
          this.$message({
            type: 'error',
            message: res.msg,
          })
        }
      })
    },
    recount() {
      // 加油量
      // this.fuel_charge = (this.inputPrice / this.oil_infor.goods.price).toFixed(
      //   2
      // );
      // this.$refs.moneyPay.calculatePrice();
    },
    checkMobile(phone) {
      if (phone.length != 11) {
        this.$message('手机号码输入不规范')
        return false
      } else {
        return true
      }
      // var telStr = /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/;
      // if (!telStr.test(phone)) {
      //   this.$message("手机号码输入不规范");
      //   return false;
      // } else {
      //   return true;
      // }
    },
    // 一键开卡
    oneOpenCard() {
      console.log(1212)
      var data = {
        token: this.token,
        app_id: this.app_id,
        mobile: this.search_con,
      }
      oneOpenCard(data).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.getData()
        } else {
          this.$message(res.msg)
        }
      })
    },
    // 获取数据
    getData() {
      if (this.search_con.length == 10) {
        // searchCardIc
        var data = {
          token: this.token,
          app_id: this.app_id,
          card_num: this.search_con,
        }
        searchCardIc(data).then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.user_infor = res.data.result
            // 賬戶总额
            this.allRechangeAccount = 0
            this.allRechangeAccount += Number(this.user_infor[0].balance)
            if (res.data.count_oil) {
              res.data.count_oil.forEach((item) => {
                this.allRechangeAccount += item.count.balance
                  ? Number(item.count.balance)
                  : 0
                console.log('数据', item.count.balance)
              })
            }
            this.allRechangeAccount =
              Math.floor(this.allRechangeAccount * 100) / 100
            this.show_user_infor = true
            this.integralNum = this.user_infor[0].point
            if (res.data.total_num == 0) {
              this.$refs.moneyPay.showDiscounts = false
            } else {
              this.$refs.moneyPay.showDiscounts = true
              if (this.inputPrice) {
                this.$refs.moneyPay.discountAll(
                  this.user_infor[0].user_level_id,
                  this.oil_infor.goods.type_id,
                  this.oil_infor.goods.id,
                  this.inputPrice,
                )
                // this.$refs.moneyPay.getAvailable_coupon();
                // this.$refs.moneyPay.openIntegral = false;
              }
            }
          } else {
            this.user_infor = ''
            this.$message(res.msg)
          }
        })
      } else {
        if (!this.checkMobile(this.search_con)) return
        let data = {
          app_id: this.app_id,
          mobile: this.search_con,
        }
        this.show_user_infor = true
        vipUserinfo(data).then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.user_infor = [res.data]
            this.integralNum = this.user_infor[0].point
            this.$refs.moneyPay.showDiscounts = true
            this.allRechangeAccount = this.user_infor[0].balance
          } else {
            this.$refs.moneyPay.showDiscounts = false
            this.user_infor = ''
            this.$message(res.msg)
          }
        })
      }
    },
    status() {
      console.log('调用')
      this.search_con = ''
      // this.show_user_infor = false
      console.log('77777', this.show_user_infor)
    },
    //
    selectPrice(item) {
      this.inputPrice = item
      // this.$refs.key_number.money = item;
    },
    // 显示用户账户 1.余额记录 2.积分记录
    showUserAccountList(i) {
      if (i == 1) {
        this.showAccountTitle = '余额变动记录'
      } else {
        this.showAccountTitle = '积分变动记录'
      }
      this.showUserAccount = true
      this.getAccountData()
    },
    getAccountData() {
      this.accountLoading = true
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.accountPage,
        mobile: this.user_infor[0].mobile,
      }
      if (this.showAccountTitle == '余额变动记录') {
        getBalanceLog(data).then((res) => {
          this.accountLoading = false
          if (res.code == 200) {
            this.accountData = res.data
            this.accountTotal = res.total
            this.accountData.forEach((item) => {
              item.show_amount =
                item.type == 1
                  ? '+' + item.amount
                  : item.type == 2
                  ? '-' + item.amount
                  : item.amount
            })
          }
        })
      } else {
        getPointLog(data).then((res) => {
          this.accountLoading = false
          if (res.code == 200) {
            this.accountData = res.data
            this.accountTotal = res.total
            this.accountData.forEach((item) => {
              item.show_style = this.styleList.find(
                (x) => x.id == item.style,
              ).name
              item.show_amount =
                item.type == 1
                  ? '+' + item.num
                  : item.type == 2
                  ? '-' + item.num
                  : item.num
            })
          }
        })
      }
    },
    handleCurrentChange(val) {
      this.accountPage = val
      this.getAccountData()
    },
    closeAccount() {
      this.showUserAccount = false
      this.accountData = []
      this.accountTotal = 0
      this.accountPage = 1
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../sub_com';
.content {
  width: 100%;
  .bodycontent {
    min-width: 1200px;
    background: transparent;
    padding: 0px 0px 0;
  }
  .screenCont {
    display: flex;
    flex-direction: column;
    .noUser {
      display: flex;
      // justify-content: center;
      align-items: center;
      margin-top: 15px;

      .el-button {
        margin-left: 20px;
      }
    }
  }
}
.user-radio {
  width: 50%;
  &-div {
    font-size: 24px;
    width: 100%;
  }
  &-p {
    font-size: 20px;
  }
  // 因为设置了scoped，所以固定的classname要用::v-deep操作
  ::v-deep {
    .el-radio-button__inner {
      border: none;
      //border-radius: 4px;
      background: #f2f2f6;
      width: 100%;
      height: 50px;
      line-height: 25px;
      text-align: center;
    }

    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      background: #00cd66;
    }
  }
}
.el-divider--horizontal {
  margin-top: 10px;
  margin-bottom: 20px;
}
.key-number {
  width: 80%;
}
</style>
<style lang="scss">
.getMoney {
  .bodycontent {
    background: transparent;
    padding: 0px 27px 10px;
  }
  .money-title {
    height: 60px;
    width: 100%;
    line-height: 60px;
    font-size: 16px;
    font-weight: 500;
    color: #696969;
  }
  .money-con {
    height: 100%;
    display: flex;
    overflow: hidden;
    padding: 10px;
    background: #fff;
    .pay_infor {
      .el-card__body {
        padding: 10px 15px;
      }
      .el-input {
        .el-input__inner {
          border: 0;
        }
      }
    }
    .submitAccounts {
      .el-card__body {
        padding: 0;
      }
    }
    .money-list {
      width: 350px;
      padding: 0 10px;
      margin-right: 10px;
      background: #fff;
    }
    .money-main {
      flex: 1;
      display: flex;
      padding: 10px;
      background: #f1f1f1;
      justify-content: space-between;
      .money-center {
        width: 60%;
        display: flex;
        position: relative;
        flex-direction: column;
        // padding-bottom: 10px;
        justify-content: space-between;
        .box-card {
          margin-bottom: 10px;
          .el-card__body {
            padding: 10px 15px;
          }
          .pay-money {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .el-input {
              flex: 1;
              text-align: right;
              .el-input__inner {
                border: 0;
                text-align: right;
                color: #f56c6c;
                font-size: 30px;
              }
              input::-webkit-input-placeholder {
                font-size: 18px;
              }
              input::-moz-input-placeholder {
                font-size: 18px;
              }
              input::-ms-input-placeholder {
                font-size: 18px;
              }
            }
          }
          .oilinfor {
            display: flex;
            justify-content: space-between;
            height: 30px;
            line-height: 30px;
            font-size: 18px;

            .oilinfor-name {
              color: #999;

              .oil {
                color: #e6a23c;
              }
            }
          }
          .weight {
            font-size: 18px;
            height: 30px;
            line-height: 30px;
            color: #999;
          }
        }

        .money-center-num {
          width: 100%;
          // height: 340px;
          display: flex;
          justify-content: space-between;
          position: relative;

          .key-right {
            flex: 1;
            margin-top: -11px;
            padding-top: 6px;
            margin-left: 5px;
            .key-right-item {
              width: 100%;
              height: 80px;
              border-radius: 6px;
              text-align: center;
              line-height: 80px;
              font-size: 16px;
              color: #f1f1f1;
              margin-top: 10px;
              cursor: pointer;
              box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
              background: #409eff;
              user-select: none;
            }
          }
        }
        .vip-card-number {
          height: 40px;
          line-height: 40px;
          font-size: 14px;
        }
        .vip-info {
          .vip-info-item {
            margin-right: 10px;
            span {
              color: #f56c6c;
            }
          }
        }
      }
    }
  }
}
</style>
